import { FC } from "react";
import {
  Box,
  Fade,
  LinearProgress,
  Card,
  Tooltip,
} from "@mui/material";
import {
  SCUIBreadCrumb,
  SCUISnackbar,
  SCUIStepper,
} from "../../atomic/molecules";
import { SCUIContent } from "../../atomic/organisms";
import { PageUrlUa } from "../../types/enums";
import {
  SCUICampaignPropertiesStep,
  SCUICampaignEarningsAndRulesStep,
  SCUICampaignWebsiteAppearanceStep,
  SCUICampaignStackableStep,
  SCUICampaignPriorityStep,
  SCUICampaignCouponStep,
  SCUICampaignSummaryStep,
} from "./components/CampaingSteps";
import { CampaignServiceComponent } from "./Campaign.helper";
import { Circle } from "@mui/icons-material";
import {
  CampaignSteps,
  CampaignStatuses,
  CampaignStep,
  CampaignStatus,
} from "../../types/enums/campaign-enums";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { hideSnackbar } from "../../stores/redux/actions";


export const CampaignManagementSave: FC<any> = (props: any) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  
  const snacbarStore = useSelector((state: any) => state.snackbar);

  const service = CampaignServiceComponent({ ...props });
  const { campaignRule } = service.campaignDetail;

  const stepperSx = {
    '& .MuiStepLabel-root': {
      cursor: 'pointer',
    },
    '& .MuiStepLabel-root.Mui-disabled': {
      cursor: campaignRule?.status !== CampaignStatus.Template && campaignRule?.status != undefined ? 'pointer' : 'default',
    },
  };

  const contentSx = {
    '& .MuiGrid-root.MuiGrid-container': {
      marginTop: 0,
    },
    '& .MuiGrid-root.MuiGrid-item': {
      paddingLeft: '16px',
      '&:first-of-type': {
        paddingLeft: 0,
      },
    }
  };

  return (
    <>
      <Box className="campaignLoading">
        <Fade in={service.loading} unmountOnExit>
          <LinearProgress />
        </Fade>
      </Box>

      <Box sx={contentSx}>
        <SCUIContent>
        <SCUIBreadCrumb
            onlyTitle={
              service.properties.campaignName.length > 0 ? (
                <>
                  {service.properties.campaignName}
                  <Tooltip
                    title={t(
                      CampaignStatuses.find(
                        (x: any) => x.id == service.properties.status
                      )?.name ?? ""
                    )}
                    style={{ fontSize: "16px!important" }}
                  >
                    <Circle
                      style={{
                        height: 16,
                        width: 16,
                        fontSize: "16px",
                        color: CampaignStatuses.find(
                          (x: any) => x.id == service.properties.status
                        )?.color,
                        marginLeft: "8px",
                      }}
                    />
                  </Tooltip>
                </>
              ) : service.properties.campaignId! > 0 ? (
                t("campaignManagement.save.editTitle")
              ) : (
                t("campaignManagement.save.createTitle")
              )
            }
            dontShowHome={true}
            homeIconLink={PageUrlUa.campaign.list.url}
            components={[
              {
                title:
                  service.properties.campaignId! > 0
                    ? t("campaignManagement.save.editTitle")
                    : t("campaignManagement.save.createTitle"),
              },
            ]}
          />

        <div style={{ marginTop: "15px", marginBottom: "15px" }}>
          <Box sx={stepperSx}>
            <SCUIStepper
              activeStep={service.step}
              stepList={CampaignSteps.map((x: any) => ({
                id: x.id,
                name: t(x.name),
              }))}
              onClick={service.stepperOnClick}
            />
          </Box>
        </div>

        <Card>
          {service.step == CampaignStep.Properties && (<SCUICampaignPropertiesStep {...props} helper={service} />)}
          {service.step == CampaignStep.RulesAndEarnings && (<SCUICampaignEarningsAndRulesStep {...props} campaignService={service}/>)}
          {service.step == CampaignStep.WebsiteAppearance && (<SCUICampaignWebsiteAppearanceStep {...props} campaignService={service} />)}
          {service.step == CampaignStep.Priority && (<SCUICampaignPriorityStep {...props} campaignService={service} />)}
          {service.step == CampaignStep.Stackables && (<SCUICampaignStackableStep {...props} campaignService={service} />)}
          {service.step == CampaignStep.Coupon && (<SCUICampaignCouponStep {...props} campaignService={service} />)}
          {service.step == CampaignStep.Summary && (<SCUICampaignSummaryStep {...props} campaignService={service} />)}
        </Card>
      </SCUIContent>
      </Box>

      <SCUISnackbar
        show={snacbarStore.open}
        messageText={snacbarStore.message}
        status={snacbarStore.status}
        autoHideDuration={snacbarStore.duration}
        onClose={() => {
          dispatch(hideSnackbar());
        }}
      />

    </>
  );
};
